import { AxiosError } from "axios";
import http from "infra/http";
import { useMutation } from "react-query";
import { VeiculoForm } from "../typings";

export function useCriarEditarVeiculo() {
  return useMutation<{ success: boolean }, AxiosError, VeiculoForm & {id?: string; unidadeId: string}>(
    async (form: VeiculoForm & {id?: string; unidadeId: string}) => {
      const formData = new FormData();

      form.foto && formData.append('file', form.foto);      
      form.marcaVeiculoId && formData.append('marcaVeiculoId', form.marcaVeiculoId);
      form.cor && formData.append('cor', form.cor);
      form.modeloVeiculoId && formData.append('modeloVeiculoId', form.modeloVeiculoId);
      form.observacao && formData.append('observacao', form.observacao);
      form.unidadeId && formData.append('unidadeId', form.unidadeId);
      form.placa && formData.append('placa', form.placa);
      form.tipoVeiculoId && formData.append('tipoVeiculoId', form.tipoVeiculoId);


      if (form.id) {
        const {data} = await http.put<{success: boolean}>(`/v1/veiculo/${form.id}`, formData)

        return data;
      }

      const {data} = await http.post<{success: boolean}>('/v1/veiculo', formData)

      return data;
    },
    {
      retry: false,
    }
  );
}

